import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.63 14.56">
    <path fill="none" d="M-1.28-1.29H15.86V15.85H-1.28Z" />
    <path
      fill="#fff;"
      d="M13,.14H1.58A1.43,1.43,0,0,0,.15,1.57V14.42L3,11.57H13a1.43,1.43,0,0,0,1.42-1.43V1.57A1.43,1.43,0,0,0,13,.14Zm0,10H2.41L1.58,11V1.58H13Zm-9.28-5H5.15V6.57H3.72Zm5.71,0h1.43V6.57H9.43Zm-2.85,0H8V6.57H6.58Z"
    />
  </svg>,
  `SMSIcon`
);
